// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   LinearProgress,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminDailyHighCourtCasesComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedCase, setSelectedCase] = useState(null);

//   const [formData, setFormData] = useState({
//     case_no: '',
//     name_of_the_parties: '',
//     fe: '',
//     date_of_filling: '',
//     status: '',
//     previous_date_of_hearing: '',
//     next_date_of_hearing: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});
//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteCase, setDeleteCase] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'case_no', field: 'case_no', headerName: 'Case No.', width: 120 },
//     { id: 'name_of_the_parties', field: 'name_of_the_parties', headerName: 'Name of the Parties', width: 160 },
//     { id: 'fe', field: 'fe', headerName: 'FE', width: 80 },
//     { id: 'date_of_filling', field: 'date_of_filling', headerName: 'Date of Filling', width: 130 },
//     { id: 'status', field: 'status', headerName: 'Status', width: 120 },
//     { id: 'previous_date_of_hearing', field: 'previous_date_of_hearing', headerName: 'Previous Date of Hearing', width: 160 },
//     { id: 'next_date_of_hearing', field: 'next_date_of_hearing', headerName: 'Next Date of Hearing', width: 160 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">Download</a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchCases();
//   }, []);

//   const fetchCases = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/daily-high-court-cases/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           case_no: item.case_no,
//           name_of_the_parties: item.name_of_the_parties,
//           fe: item.fe,
//           date_of_filling: item.date_of_filling,
//           status: item.status,
//           previous_date_of_hearing: item.previous_date_of_hearing,
//           next_date_of_hearing: item.next_date_of_hearing,
//           links: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch daily high court cases:', error);
//         setSnackbarMessage('Failed to load Daily High Court Cases data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddCase = () => {
//     setIsEditMode(false);
//     setFormData({
//       case_no: '',
//       name_of_the_parties: '',
//       fe: '',
//       date_of_filling: '',
//       status: '',
//       previous_date_of_hearing: '',
//       next_date_of_hearing: '',
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (courtCase) => {
//     setIsEditMode(true);
//     setSelectedCase(courtCase);
//     setFormData({
//       case_no: courtCase.case_no,
//       name_of_the_parties: courtCase.name_of_the_parties,
//       fe: courtCase.fe,
//       date_of_filling: courtCase.date_of_filling,
//       status: courtCase.status,
//       previous_date_of_hearing: courtCase.previous_date_of_hearing,
//       next_date_of_hearing: courtCase.next_date_of_hearing,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (courtCase) => {
//     setDeleteCase(courtCase);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/daily-high-court-cases/${deleteCase.id}/`)
//       .then(() => {
//         setSnackbarMessage('Daily High Court Case deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchCases();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete Daily High Court Case.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteCase(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.case_no) errors.case_no = 'Case No. is required';
//     if (!formData.name_of_the_parties) errors.name_of_the_parties = 'Name of the Parties is required';
//     if (!formData.fe) errors.fe = 'FE is required';
//     if (!formData.date_of_filling) errors.date_of_filling = 'Date of Filling is required';
//     if (!formData.status) errors.status = 'Status is required';
//     if (!formData.previous_date_of_hearing) errors.previous_date_of_hearing = 'Previous Date of Hearing is required';
//     if (!formData.next_date_of_hearing) errors.next_date_of_hearing = 'Next Date of Hearing is required';
//     // if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('case_no', formData.case_no);
//     form.append('name_of_the_parties', formData.name_of_the_parties);
//     form.append('fe', formData.fe);
//     form.append('date_of_filling', formData.date_of_filling);
//     form.append('status', formData.status);
//     form.append('previous_date_of_hearing', formData.previous_date_of_hearing);
//     form.append('next_date_of_hearing', formData.next_date_of_hearing);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(
//           `${API_BASE_URL}/home-notification/daily-high-court-cases/${selectedCase.id}/`,
//           form,
//           {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//           }
//         );
//         setSnackbarMessage('Daily High Court Case updated successfully.');
//       } else {
//         await api.post(
//           `${API_BASE_URL}/home-notification/daily-high-court-cases/`,
//           form,
//           {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//           }
//         );
//         setSnackbarMessage('Daily High Court Case added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchCases();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit Daily High Court Case.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Daily High Court Cases
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddCase} disabled={uploading}>
//           Add Case
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Daily High Court Case' : 'Add Daily High Court Case'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Case No."
//             type="text"
//             fullWidth
//             value={formData.case_no}
//             error={!!formErrors.case_no}
//             helperText={formErrors.case_no}
//             onChange={(e) => setFormData({ ...formData, case_no: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Name of the Parties"
//             type="text"
//             fullWidth
//             value={formData.name_of_the_parties}
//             error={!!formErrors.name_of_the_parties}
//             helperText={formErrors.name_of_the_parties}
//             onChange={(e) => setFormData({ ...formData, name_of_the_parties: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="FE"
//             type="text"
//             fullWidth
//             value={formData.fe}
//             error={!!formErrors.fe}
//             helperText={formErrors.fe}
//             onChange={(e) => setFormData({ ...formData, fe: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Date of Filling"
//             type="date"
//             fullWidth
//             value={formData.date_of_filling}
//             error={!!formErrors.date_of_filling}
//             helperText={formErrors.date_of_filling}
//             onChange={(e) => setFormData({ ...formData, date_of_filling: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Status"
//             type="text"
//             fullWidth
//             value={formData.status}
//             error={!!formErrors.status}
//             helperText={formErrors.status}
//             onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Previous Date of Hearing"
//             type="date"
//             fullWidth
//             value={formData.previous_date_of_hearing}
//             error={!!formErrors.previous_date_of_hearing}
//             helperText={formErrors.previous_date_of_hearing}
//             onChange={(e) => setFormData({ ...formData, previous_date_of_hearing: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={uploading}
//           />
//           <TextField
//             margin="dense"
//             label="Next Date of Hearing"
//             type="text"
//             fullWidth
//             value={formData.next_date_of_hearing}
//             error={!!formErrors.next_date_of_hearing}
//             helperText={formErrors.next_date_of_hearing}
//             onChange={(e) => setFormData({ ...formData, next_date_of_hearing: e.target.value })}
//             disabled={uploading}
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: '8px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error" sx={{ mt: 1 }}>
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedCase?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedCase.links}`} target="_blank" rel="noopener noreferrer">
//                   Download
//                 </a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
//             {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this Daily High Court Case?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminDailyHighCourtCasesComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedCase, setSelectedCase] = useState(null);

  const [formData, setFormData] = useState({
    case_no: '',
    name_of_the_parties: '',
    fe: '',
    date_of_filling: '',
    status: '',
    previous_date_of_hearing: '',
    next_date_of_hearing: '',
    advocate_name: '',
    appearence_by: '',
  });

  const [statusOther, setStatusOther] = useState('');
  const [appearanceOther, setAppearanceOther] = useState('');

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteCase, setDeleteCase] = useState(null);

  const statusOptions = [
    // 'Final hearing',
    // 'admission',
    // 'hearing on IA',
    // 'orders',
    // 'premilinary hearing B-group',
    // 'non-comlians',
    // 'notiece',
    // 'Disposed',
    // 'reserved for judgement',
    // 'others',

    'Final hearing',
    'Admission',
    'Hearing on IA',
    'Orders',
    'Preliminary hearing B-group',
    'Non-compliance',
    'Notice',
    'Disposed',
    'Reserved for judgement',
    "Fresh matters",
    "Further Hearing", 
    "Preliminary Hearing",
    'Others'
  ];

  const appearanceOptions = [
    'JRCL',
    'SRCL',
    'CL',
    'others',
  ];

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'case_no', field: 'case_no', headerName: 'Case No.', width: 120 },
    { id: 'name_of_the_parties', field: 'name_of_the_parties', headerName: 'Name of the Parties', width: 160 },
    { id: 'advocate_name', field: 'advocate_name', headerName: 'Advocate Name', width: 160 },
    { id: 'fe', field: 'fe', headerName: 'FE', width: 80 },
    { id: 'date_of_filling', field: 'date_of_filling', headerName: 'Date of Filling', width: 130 },
    { id: 'previous_date_of_hearing', field: 'previous_date_of_hearing', headerName: 'Previous Date of Hearing', width: 160 },
    { id: 'next_date_of_hearing', field: 'next_date_of_hearing', headerName: 'Next Date of Hearing', width: 160 },
    { id: 'appearence_by', field: 'appearence_by', headerName: 'Appearance By', width: 120 },
    { id: 'status', field: 'status', headerName: 'Status', width: 120 },
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value.startsWith('http') ? params.value : `${API_BASE_URL}${params.value}`} target="_blank" rel="noopener noreferrer">Download</a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchCases();
  }, []);

  const fetchCases = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/daily-high-court-cases/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          case_no: item.case_no,
          name_of_the_parties: item.name_of_the_parties,
          fe: item.fe,
          date_of_filling: item.date_of_filling,
          status: item.status,
          previous_date_of_hearing: item.previous_date_of_hearing,
          next_date_of_hearing: item.next_date_of_hearing,
          advocate_name: item.advocate_name || '',
          appearence_by: item.appearence_by || '',
          links: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch daily high court cases:', error);
        setSnackbarMessage('Failed to load Daily High Court Cases data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddCase = () => {
    setIsEditMode(false);
    setFormData({
      case_no: '',
      name_of_the_parties: '',
      fe: '',
      date_of_filling: '',
      status: '',
      previous_date_of_hearing: '',
      next_date_of_hearing: '',
      advocate_name: '',
      appearence_by: '',
    });
    setStatusOther('');
    setAppearanceOther('');
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (courtCase) => {
    setIsEditMode(true);
    setSelectedCase(courtCase);
    setFormData({
      case_no: courtCase.case_no,
      name_of_the_parties: courtCase.name_of_the_parties,
      fe: courtCase.fe,
      date_of_filling: courtCase.date_of_filling,
      status: statusOptions.includes(courtCase.status) ? courtCase.status : 'others',
      previous_date_of_hearing: courtCase.previous_date_of_hearing,
      next_date_of_hearing: courtCase.next_date_of_hearing,
      advocate_name: courtCase.advocate_name || '',
      appearence_by: appearanceOptions.includes(courtCase.appearence_by) ? courtCase.appearence_by : 'others',
    });
    setStatusOther(statusOptions.includes(courtCase.status) ? '' : courtCase.status);
    setAppearanceOther(appearanceOptions.includes(courtCase.appearence_by) ? '' : courtCase.appearence_by);
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (courtCase) => {
    setDeleteCase(courtCase);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(`/home-notification/daily-high-court-cases/${deleteCase.id}/`)
      .then(() => {
        setSnackbarMessage('Daily High Court Case deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchCases();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete Daily High Court Case.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteCase(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.case_no) errors.case_no = 'Case No. is required';
    if (!formData.name_of_the_parties) errors.name_of_the_parties = 'Name of the Parties is required';
    if (!formData.fe) errors.fe = 'FE is required';
    if (!formData.date_of_filling) errors.date_of_filling = 'Date of Filling is required';
    if (!formData.status) errors.status = 'Status is required';
    else if (formData.status === 'others' && !statusOther.trim()) errors.status = 'Specify other status';
    if (!formData.previous_date_of_hearing) errors.previous_date_of_hearing = 'Previous Date of Hearing is required';
    if (!formData.next_date_of_hearing) errors.next_date_of_hearing = 'Next Date of Hearing is required';
    // appearance validation
    if (!formData.appearence_by) errors.appearence_by = 'Appearance By is required';
    else if (formData.appearence_by === 'others' && !appearanceOther.trim()) errors.appearence_by = 'Specify other appearance';


    if (selectedFile && selectedFile.size > 10 * 1024 * 1024) errors.file = 'File size must be less than 10MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file && file.size > 10 * 1024 * 1024) {
  //     setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 10MB' }));
  //     setSelectedFile(null);
  //   } else {
  //     setFormErrors((prev) => ({ ...prev, file: null }));
  //     setSelectedFile(file);
  //   }
  // };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  
  if (!file) return;

  // Check if file is PDF
  const isPdf = file.type === 'application/pdf' || 
                file.name.toLowerCase().endsWith('.pdf');
  
  if (!isPdf) {
    setFormErrors((prev) => ({ ...prev, file: 'Only PDF files are allowed' }));
    setSelectedFile(null);
    e.target.value = ''; // Clear input
    return;
  }
  
  // Check file size (10MB)
  if (file.size > 10 * 1024 * 1024) {
    setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 10MB' }));
    setSelectedFile(null);
    e.target.value = ''; // Clear input
    return;
  }
  
  // All validations passed
  setFormErrors((prev) => ({ ...prev, file: null }));
  setSelectedFile(file);
};


  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const submitData = {
      ...formData,
      status: formData.status === 'others' ? statusOther.trim() : formData.status,
      appearence_by: formData.appearence_by === 'others' ? appearanceOther.trim() : formData.appearence_by,
    };

    const form = new FormData();
    form.append('case_no', submitData.case_no);
    form.append('name_of_the_parties', submitData.name_of_the_parties);
    form.append('fe', submitData.fe);
    form.append('date_of_filling', submitData.date_of_filling);
    form.append('status', submitData.status);
    form.append('previous_date_of_hearing', submitData.previous_date_of_hearing);
    form.append('next_date_of_hearing', submitData.next_date_of_hearing);
    form.append('advocate_name', submitData.advocate_name);
    form.append('appearence_by', submitData.appearence_by);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(
          `/home-notification/daily-high-court-cases/${selectedCase.id}/`,
          form,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
          }
        );
        setSnackbarMessage('Daily High Court Case updated successfully.');
      } else {
        await api.post(
          `/home-notification/daily-high-court-cases/`,
          form,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
          }
        );
        setSnackbarMessage('Daily High Court Case added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchCases();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit Daily High Court Case.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Daily High Court Cases
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddCase} disabled={uploading}>
          Add Case
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Daily High Court Case' : 'Add Daily High Court Case'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Case No."
            type="text"
            fullWidth
            value={formData.case_no}
            error={!!formErrors.case_no}
            helperText={formErrors.case_no}
            onChange={(e) => setFormData({ ...formData, case_no: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Name of the Parties"
            type="text"
            fullWidth
            value={formData.name_of_the_parties}
            error={!!formErrors.name_of_the_parties}
            helperText={formErrors.name_of_the_parties}
            onChange={(e) => setFormData({ ...formData, name_of_the_parties: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="FE"
            type="text"
            fullWidth
            value={formData.fe}
            error={!!formErrors.fe}
            helperText={formErrors.fe}
            onChange={(e) => setFormData({ ...formData, fe: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Date of Filling"
            type="date"
            fullWidth
            value={formData.date_of_filling}
            error={!!formErrors.date_of_filling}
            helperText={formErrors.date_of_filling}
            onChange={(e) => setFormData({ ...formData, date_of_filling: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />

          <TextField
            select
            margin="dense"
            label="Status"
            fullWidth
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
            SelectProps={{ native: true }}
            disabled={uploading}
            error={!!formErrors.status}
            helperText={formErrors.status}
          >
            <option value="" />
            {statusOptions.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </TextField>
          {formData.status === 'others' && (
            <TextField
              margin="dense"
              label="Specify Other Status"
              fullWidth
              value={statusOther}
              onChange={(e) => setStatusOther(e.target.value)}
              disabled={uploading}
            />
          )}

          <TextField
            margin="dense"
            label="Previous Date of Hearing"
            type="date"
            fullWidth
            value={formData.previous_date_of_hearing}
            error={!!formErrors.previous_date_of_hearing}
            helperText={formErrors.previous_date_of_hearing}
            onChange={(e) => setFormData({ ...formData, previous_date_of_hearing: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />

          <TextField
            margin="dense"
            label="Next Date of Hearing"
            type="text"
            fullWidth
            value={formData.next_date_of_hearing}
            error={!!formErrors.next_date_of_hearing}
            helperText={formErrors.next_date_of_hearing}
            onChange={(e) => setFormData({ ...formData, next_date_of_hearing: e.target.value })}
            disabled={uploading}
          />

          <TextField
            margin="dense"
            label="Advocate Name"
            type="text"
            fullWidth
            value={formData.advocate_name}
            onChange={(e) => setFormData({ ...formData, advocate_name: e.target.value })}
            disabled={uploading}
          />

          <TextField
            select
            margin="dense"
            label="Appearance By"
            fullWidth
            value={formData.appearence_by}
            onChange={(e) => setFormData({ ...formData, appearence_by: e.target.value })}
            SelectProps={{ native: true }}
            disabled={uploading}
            error={!!formErrors.appearence_by}
            helperText={formErrors.appearence_by}
          >
            <option value="" />
            {appearanceOptions.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </TextField>
          {formData.appearence_by === 'others' && (
            <TextField
              margin="dense"
              label="Specify Other Appearance"
              fullWidth
              value={appearanceOther}
              onChange={(e) => setAppearanceOther(e.target.value)}
              disabled={uploading}
            />
          )}

          <Box mt={2}>
            <input
              accept="*"
              style={{ display: 'block', marginTop: '8px' }}
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedCase?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={`${API_BASE_URL}${selectedCase.links}`} target="_blank" rel="noopener noreferrer">
                  Download
                </a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
            {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this Daily High Court Case?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};


